import { Navigate } from 'react-router-dom';
import { useAuthStore, personaFor, useRememberKids } from '@/entities/session';
import { AppShell } from '@/widgets/app-shell/AppShell';

/** Picks the kid vs family shell from the authenticated user's persona (FSD `widgets`). */
export function PersonaShell(): React.ReactElement {
  const user = useAuthStore((s) => s.user);
  // On a guardian session, remember this household's kids on the device for the kid-login picker.
  useRememberKids();
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return <AppShell persona={personaFor(user)} />;
}
